import React from 'react'
import logo from '../../img/intelli X Logo.png'
import vect from '../../img/Vector (32).png'
import flag from '../../img/flag.png'
import {HiOutlineArrowNarrowRight} from 'react-icons/hi'
import {FcOnlineSupport} from 'react-icons/fc'
import {IoCallSharp} from 'react-icons/io5'
import {AiOutlineMail} from 'react-icons/ai'
import {IoLocationSharp} from 'react-icons/io5'
import { NavLink } from 'react-router-dom'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
  

const Talk = () => {
  return (
    <>
    <Header/>
         <section style={{paddingTop:'110px'}}>
      <div className='container'>
       <div className='row'>
        <div className='col-lg-7 col-md-6 col-sm-12 mt-4'>
           
        <h1>Our Team of Experts <br/>
         will help you to Get<br/>
         Started with</h1>

           <div className='mt-3  ' style={{display:'flex', alignItems:'center'}}>
            <img src={logo} alt='Image' style={{width:'40%'}}/>
            <HiOutlineArrowNarrowRight className='mt-2 ms-4' style={{fontSize:'35px'}}/>
           </div> 

           
           <div className='mt-3'>
           <button type='btn ms-2  ' style={{border:'none', backgroundColor:'#000', color:'#fff', padding:'10px 25px', borderRadius:'8px'}}> <FcOnlineSupport className='me-2'  style={{fontSize:'20px'}}/> Talk to Sales</button>
           </div>


        </div> 
         
        <div className='col-lg-4 col-md-6 col-sm-12'>
         
        <img src={vect} alt='img' className='p-4' style={{width:'100%'}}/>
        </div>
       </div>
      </div>
      </section>




      <section>
         <div className='container'>
          <div className='row'>
           <div className='col-lg-12 col-sm-12 mt-5'>
            
           <h2 className='text-center'>Contact Us</h2>
           </div>

             

           <div className='col-lg-5 col-sm-12 m-auto'>
            <div className='row mt-4'>
            <div className='col-lg-6 col-sm-12'>
              
            <h5 style={{color:'#949494'}}>Select your Region</h5>
            </div>


            <div className='col-lg-4 col-sm-12'> 
            <select class="form-select" aria-label="Default select example" style={{backgroundColor:'#EEF2FF', boxShadow:'none'}}>
              <option selected> <img src={flag} alt='img' style={{width:'55px'}}/>India</option>
              <option value="1"> <img src={flag} alt='img' /> Vietnam</option>
              <option value="2">Nepal</option>
              <option value="3">Bhutan</option>
              <option value="4">Thailand</option>
              <option value="5">China</option>
            </select>
            </div>
            </div>
            
           </div>
          </div>
         </div>
       
      </section>

      <section>
       <div className='container mt-5'>
        <div className='row'>
        <div className='col-lg-5 col-md-6 col-sm-12'>


          <NavLink to='tel: 8004552635' style={{textDecoration:'none', color:'#000'}}>   
          <div className='row'>
          <div className='col-1 mt-1'>
          <IoCallSharp style={{fontSize:'20px'}}/>
          </div>
          <div className='col-10'>
          <h4>24*7 Toll Free</h4>
          <p>1800-1254-1254</p>

          </div>
          </div>
          </NavLink>

          <NavLink to='mailto: abc@example.com' style={{textDecoration:'none', color:'#000'}}>  
          <div className='row mt-5'>
          <div className='col-1  '>
          <AiOutlineMail style={{fontSize:'20px'}}/>
          </div>
          <div className='col-10'>
          <h4>E-Mail</h4>
          <p>sales@intellix360.com</p>

          </div>
          </div>

          </NavLink>


          
           <NavLink  to='https://goo.gl/maps/aUWWgJ4HWDN3cFLW7' style={{textDecoration:'none', color:'#000'}}>

          <div className='row mt-5'>
          <div className='col-1 '>
          <IoLocationSharp style={{fontSize:'20px'}}/>
          </div>
          <div className='col-10'>
          <h4>Office</h4>
          <p>101-103 Chanda Tower, Vaishali Nagar, <br/>Jaipur - 302021</p>

          </div>
          </div> 

          </NavLink>


        </div> 
        <div className='col-lg-6 col-sm-12'>
        
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3557.942082346434!2d75.74378747522546!3d26.905333160408016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db57145940dfd%3A0x42c8d9bb38d89164!2sChanda%20Tower!5e0!3m2!1sen!2sin!4v1681800336763!5m2!1sen!2sin" width="100%" height="100%"   allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
        </div>
       </div>
      </section>



        
      <section className='mt-5'>
        <Footer/>
      </section>
    </>
  )
}

export default Talk
